import React, { useEffect, useState } from "react";
import { TablePagination, Button, TableRow, Table, TableHead, TableBody, Typography, TableCell, Card, Box, Grid
  ,TableContainer,
        Paper,
 } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EventService from "./Locality/Service/eventService";
import StudentService from "./Locality/Service/studentService";
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import UserProfileCard from "./UserProfileCard";
import StudentCards from "./UserProfileCard";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
}));

export default function Assignment() {
  const classes = useStyles();
  const [eventList, setEventList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    fetchStudentList();
  }, []);



  const handleStudentClick = (studentId, classId) => {

    getEventList(studentId, classId);

    // You can now fetch the student's assignments or do anything with this ID
  };
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = (values, status) => {
    values.resubmit = status;
    values.status = values.eventStudentDetailsListId?.status;
    values._id = values.eventStudentDetailsListId?._id
    EventService.upadeStudentEvent(values).then((res) => {
      handleClose();
      if (values.eventStudentDetailsListId?.studentId) {
        getEventList(values.eventStudentDetailsListId?.studentId._id, values.classId._id);

      }

      alert("Submited Successfully.");
    }).catch((err) => {
    });
  };
  const fetchStudentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    StudentService.findStudentList({ userId: userDetails._id })
      .then((res) => {
        const mappedStudents = res.map((student) => ({
          ...student,
          fullName: `${student.firstName} ${student.lastName}`,
        }));
        setStudentList(mappedStudents);
        if (mappedStudents.length > 0) {
          getEventList(mappedStudents[0]._id, mappedStudents[0].classId._id);
        }

      })
      .catch((err) => console.error(err));
  };

  const getEventList = (studentId, classId) => {
    EventService.findEventList({ studentId, classId })
      .then((res) => {
        const formattedEvents = res.map((event) => ({
          ...event,
          // Always ensure we have a single detail object for this student
          eventStudentDetailsListId: event.eventStudentDetailsListId && event.eventStudentDetailsListId.length
            ? event.eventStudentDetailsListId[0]
            : {},
          // Normalize uploaded documents to an array of URLs
          imageURL: Array.isArray(event.imageURL)
            ? event.imageURL
            : event.imageURL
            ? [event.imageURL]
            : [],
          rawDate: event.date || "",
          date: event.date ? formatDate(event.date) : "",
          dueDate: event.dueDate ? formatDateDMY(event.dueDate) : "", // ✅ format due date
        }));
        setEventList(formattedEvents);
      })
      .catch((err) => console.error(err));
  };
// ✅ format DD/MM/YYYY
const formatDateDMY = (date) => {
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
};


  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year.slice(2)}`;
  };

  const openInNewTab = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const downloadFromUrl = (url, index) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `assignment-document-${index + 1}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileName = (url) => {
    try {
      const path = (url || "").split("/").pop() || url;
      return (path || "").split("?")[0] || "document";
    } catch {
      return "document";
    }
  };

  const fetchEventDocumentUrl = async (event) => {
    try {
      const fullEvent = await EventService.getEventbyId(event._id);
      const images = Array.isArray(fullEvent.imageURL)
        ? fullEvent.imageURL
        : fullEvent.imageURL
        ? [fullEvent.imageURL]
        : [];
      return images[0] || "";
    } catch (err) {
      console.error("Failed to fetch event document", err);
      return "";
    }
  };

  // Parent document upload for this assignment row
  const handleParentFileChange = async (e, event) => {
    const file = e.target.files && e.target.files[0];
    if (!file || !event?.eventStudentDetailsListId?._id) return;

    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("imageName", file.name);

      const uploadRes = await EventService.uploadImage(formData);
      const url = uploadRes?.url;
      if (!url) {
        alert("Failed to upload document.");
        return;
      }

      const existing =
        event.eventStudentDetailsListId.submissionFiles || [];
      const updatedFiles = [...existing, url];

      await EventService.upadeStudentEvent({
        _id: event.eventStudentDetailsListId._id,
        submissionFiles: updatedFiles,
        status: "Submitted",
      });

      // Update local UI state so button label and status update immediately
      setEventList((prev) =>
        prev.map((ev) =>
          ev._id === event._id
            ? {
                ...ev,
                eventStudentDetailsListId: {
                  ...ev.eventStudentDetailsListId,
                  submissionFiles: updatedFiles,
                  status: "Submitted",
                },
              }
            : ev
        )
      );

      alert("Document uploaded successfully and status updated.");
    } catch (err) {
      console.error("Parent document upload failed", err);
      alert("Failed to upload document.");
    } finally {
      if (e?.target) e.target.value = "";
    }
  };

  return (
    <>
      <PageTitle title="Assignment" />

      <>
        <Card sx={{ maxWidth: 345 }}>
          {studentList.length > 1 && (<Box style={{ margin: 15 }}>
            <StudentCards studentList={studentList} onStudentSelect={handleStudentClick} />

          </Box>)}
        </Card>
        <br />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Widget title="Assignments" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                              <TableContainer component={Paper} style={{ maxHeight: 500 }}>
              
              <Table stickyHeader className="mb-0">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Assignment</StyledTableCell>
                    <StyledTableCell>Assignment Date</StyledTableCell>
                    <StyledTableCell>Due Date</StyledTableCell>
                    <StyledTableCell>Uploaded Document</StyledTableCell>
                    <StyledTableCell>Remarks</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Request for Resubmission</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[...eventList]
                    .sort((a, b) => new Date(b.rawDate) - new Date(a.rawDate)) // Latest to Oldest
                    .map((event) => {
                      const isPastDue = new Date() > new Date(event.dueDate);
                      return (
                        <TableRow key={event._id}>
                          <TableCell>{event.eventName}</TableCell>
                          <TableCell>{event.date}</TableCell>
                          <TableCell
                            style={{
                              color: event.eventStudentDetailsListId?.status === "Submitted" ? "red" : "inherit",
                              fontWeight: event.eventStudentDetailsListId?.status === "Submitted" ? "bold" : "normal"
                            }}
                          >
                            {event.dueDate}
                          </TableCell>
                          <TableCell>
                            <Box display="flex" flexDirection="column" style={{ gap: 6 }}>
                              <Button
                                size="small"
                                startIcon={<VisibilityIcon style={{ fontSize: 18 }} />}
                                onClick={async () => {
                                  const url = await fetchEventDocumentUrl(event);
                                  if (url) {
                                    openInNewTab(url);
                                  } else {
                                    alert("No document uploaded for this assignment.");
                                  }
                                }}
                                style={{ color: "#0f3b62", minWidth: "auto", padding: "2px 8px", marginBottom: 4 }}
                              >
                                View
                              </Button>

                              {(() => {
                                // Treat the assignment as uploaded if:
                                // - backend status is Submitted (persists across refresh), OR
                                // - we have one or more saved submission files
                                const hasParentUpload =
                                  !!(
                                    event.eventStudentDetailsListId &&
                                    (
                                      event.eventStudentDetailsListId.status === "Submitted" ||
                                      (
                                        event.eventStudentDetailsListId.submissionFiles &&
                                        event.eventStudentDetailsListId.submissionFiles.length > 0
                                      )
                                    )
                                  );
                                const uploadLabel = hasParentUpload
                                  ? "Uploaded"
                                  : "Upload Document";
                                const uploadStyle = hasParentUpload
                                  ? {
                                      backgroundColor: "#2e7d32",
                                      color: "#ffffff",
                                      minWidth: "auto",
                                      padding: "2px 8px",
                                    }
                                  : {
                                      color: "#0f3b62",
                                      minWidth: "auto",
                                      padding: "2px 8px",
                                    };

                                // If already uploaded, disable button and don't allow selecting again
                                if (hasParentUpload) {
                                  return (
                                    <Button
                                      size="small"
                                      startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                                      style={uploadStyle}
                                      disabled
                                    >
                                      {uploadLabel}
                                    </Button>
                                  );
                                }

                                return (
                                  <>
                                    <input
                                      id={`parent-upload-${event._id}`}
                                      type="file"
                                      accept="image/*,application/pdf"
                                      style={{ display: "none" }}
                                      onChange={(e) => handleParentFileChange(e, event)}
                                    />
                                    <label htmlFor={`parent-upload-${event._id}`}>
                                      <Button
                                        size="small"
                                        component="span"
                                        startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                                        style={uploadStyle}
                                      >
                                        {uploadLabel}
                                      </Button>
                                    </label>
                                  </>
                                );
                              })()}
                            </Box>
                          </TableCell>
                          <TableCell>{event.discription || event.description}</TableCell>
                          <TableCell>{event.eventStudentDetailsListId?.status}</TableCell>
                          <TableCell className="pl-3 fw-normal">
                            {(isPastDue && event.eventStudentDetailsListId?.resubmit === 'Not Submitted') ? (
                              <Button
                                variant="contained"
                                style={{ backgroundColor: "rgb(15 59 98)", color: 'white' }}
                                onClick={() => onSubmit(event, "Resubmit")}
                              >
                                Resubmit
                              </Button>
                            ) : null}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

              </Table>
              </TableContainer >
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 50]}
                count={eventList.length}
                page={0}
                rowsPerPage={10}
                onPageChange={() => { }}
              />
            </Widget>
          </Grid>
        </Grid>
      </>

    </>
  );
}
